export default __webpack_public_path__ + "20e2ae1cad9191cfdcabfa04cc2ebd4d.png";